// Reads theme palette colors exposed as CSS custom properties on :root.
// Any theme can expose swatches here just by declaring `--theme-<name>: <color>;`
// in its stylesheet — no JS changes needed to pick them up.
export function getThemeSwatches() {
  const rootStyles = getComputedStyle(document.documentElement)
  const themeProps = Array.from(rootStyles).filter((prop) => prop.startsWith('--theme-'))

  return themeProps
    .map((prop) => ({
      value: rootStyles.getPropertyValue(prop).trim(),
      label: prop
        .replace('--theme-', '')
        .replace(/-/g, ' ')
        .replace(/\b\w/g, (char) => char.toUpperCase())
    }))
    .filter((swatch) => swatch.value)
}
